<template>
  <main class="page search-page mypc">
    <div class="container container--small">
      <div class="row">
        <div v-if="searchError" class="column column--2-3">
          <p>Error. Please try again later</p>
        </div>
        <div v-else-if="totalCount" class="column column--2-3">
          <div class="search-page__info">
            <div class="search-page__info-count">
              <span>{{ totalCount >= 10000 ? "10,000+" : totalCount }} results</span>
              <template v-if="searchValue">
                found for
                <span id="results-for">{{ searchValue }}</span>
              </template>
            </div>
            <div v-if="containsQuery()" class="search-page__info-sorting">
              <div class="search-page__info-sorting-label">Sort by</div>
              <el-dropdown
                split-button
                trigger="click"
                @command="handleClickSort"
              >
                {{ sort.find((el) => el.value === sortValue).name }}
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="item in sort"
                    :key="item.value"
                    :command="item.value"
                  >
                    {{ item.name }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div class="section">
            <el-tabs ref="resultsTabs" v-model="activeTab">
              <el-tab-pane :label="`All (${totalCount >= 10000 ? '10,000+' : totalCount})`" name="all">
                <div
                  v-for="article in allResultsTab"
                  :key="article.nid"
                  class="search-page__result-item"
                  style="margin-top: 20px"
                >
                  <ArticleSearchCard
                    :key="article.nid"
                    :title="markedWords(article.title)"
                    :desc="markedWords(article.body)"
                    :link="article.url"
                    :date="article.date"
                    :author="article.author_name"
                    :tags="article.tags"
                    :has-access="
                      article.type === 'regulatory_update'
                        ? checkHsAccess(article.jurisdictions)
                        : true
                    "
                  />
                </div>
                <div
                  v-if="totalCount && totalCount > 10"
                  class="search-page__pagination"
                >
                  <Pagination
                    :current-page="currentPage"
                    :total="pagination.count"
                    @changePage="searchPaging"
                  />
                </div>
              </el-tab-pane>
              <el-tab-pane
                v-for="item in results"
                :key="item.name"
                :label="`${item.name}(${item.count})`"
                :disabled="item.count === 0"
              >
                <div
                  v-for="article in item.results"
                  :key="article.nid"
                  class="search-page__result-item"
                  style="margin-top: 20px"
                >
                  <ArticleSearchCard
                    :key="article.nid"
                    :title="markedWords(article.title)"
                    :desc="markedWords(article.body)"
                    :link="article.url"
                    :date="article.date"
                    :author="article.author_name"
                    :tags="article.tags"
                    :has-access="
                      article.type === 'regulatory_update'
                        ? checkHsAccess(article.jurisdictions)
                        : true
                    "
                  />
                </div>
                <div
                  v-if="item.count && item.count > 10"
                  class="search-page__pagination"
                >
                  <Pagination
                    :current-page="currentPage"
                    :total="item.count"
                    @changePage="searchPaging"
                  />
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
          <!-- <div
            v-if="totalCount && totalCount > 10"
            class="search-page__pagination"
          >
            <Pagination
              :current-page="currentPage"
              :total="pagination.count"
              @changePage="searchPaging"
            />
          </div> -->
        </div>
        <div v-else class="column column--2-3">
          <p>No results</p>
        </div>
        <div class="column column--1-3">
          <Sidebar :props-handle-click-close="toggleSidebar" class="test">
            <FilterBlock
              ref="filterBlock"
              :title="'SEARCH FILTERS'"
              :reset="true"
              :filter-data="searchFilter"
              :initial-selection="selectedFilterIds"
              @filterChanged="filterChanged"
              @filterReset="filterReset"
            />
            <div
              class="watchlist section section-border--top section-border--right"
            >
              <TitleBlock text="Watchlist" color="brightblue" />
              <div class="watchlist__wrapper">
                <div
                  v-for="item in watchlist"
                  :key="item.id"
                  class="watchlist__item"
                  @click="onWatchlistItemClicked(item.id, item.tags)"
                >
                  <span>{{ item.name }}</span>
                  <a
                      class="watchlist__item-link"
                      @click.stop="handleLinkAction(item)"
                    >
                      Edit
                    </a>
                </div>
              </div>
            </div>
          </Sidebar>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapState } from "vuex";
// import { find } from "lodash";
import { mobile } from "../../mixin/mobile";
import { matomoCustom } from "../../mixin/matomoCustom";
import { filters } from "../../mixin/filters";
// import filter from "../utils/filter";
import { checkAccess } from "@/utils/constants";
import { markedWords } from "~/mixin/markedWords";

export default {
  name: "SearchV1",
  components: {
    FilterBlock: () => import("../elements/FilterBlock"),
    // SearchMultiple: () => import("../elements/SearchMultiple"),
    Sidebar: () => import("../sidebar/Sidebar"),
    ArticleSearchCard: () => import("../elements/ArticleSearchCard"),
    Pagination: () => import("../elements/Pagination"),
    // Burger: () => import("../elements/Burger"),
    // Link: () => import("../elements/Link"),
    TitleBlock: () => import("../elements/TitleBlock"),
  },
  mixins: [mobile, matomoCustom, filters, markedWords],
  data() {
    return {
      searchValue: "",
      activeTab: "all",
      sortValue: "relevance",
      sort: [
        {
          name: "Publish date",
          value: "date",
        },
        {
          name: "Relevance",
          value: "relevance",
        },
      ],
      showFilters: false,
      showSort: false,
      transformToPopup: true,
      loadingData: false,
      searchError: false,
      currentPage: 1,
      updatesFilters: { queryParams: null },
      filtersArr: [],
      filtersActive: false,
      selectedFilterIds: [],
    };
  },
  async fetch({ store }) {
    if (!store.state.Search.filters) {
      await store
        .dispatch("Search/getViewData", {
          url: "/filters/search",
        })
        .then(({ data }) => {
          store.commit("Search/setData", {
            label: "searchFilter",
            data,
          });
        })
        .catch((error) => console.error(error));
    }

    await store
      .dispatch("Requirement/getViewData", {
        url: "/my-old-watchlists",
      })
      .then(({ data }) => {
        store.commit("Search/setData", {
          label: "watchlist",
          data,
        });
      })
      .catch((error) => console.error(error));
  },
  head() {
    return { title: "VIXIO PaymentsCompliance - Search" };
  },
  computed: {
    ...mapState("Auth", ["subscriptions"]),
    ...mapState("Search", [
      "totalCount",
      "searchQuery",
      "searchText",
      "results",
      "allResultsTab",
      "pageCount",
      "searchFilter",
      "watchlist",
    ]),
    pagination() {
      return {
        count: this.pageCount,
      };
    },
  },
  watch: {
    searchText(val) {
      this.searchValue = val;
      const query = { ...this.$route.query };
      query.query = val;
      query.offset = 0;
      this.$router.push({ query });
    },
    $route() {
      if (this.$route.fullPath) {
        this.selectedFilterIds = this.filterIdsFromUrl(this.$route.fullPath);
      }

      this.getResults();
      this.checkQuery();
    },
  },
  beforeMount() {
    if (this.$route.fullPath) {
      this.selectedFilterIds = this.filterIdsFromUrl(this.$route.fullPath);
    }
  },
  mounted() {
    this.getResults();
    this.checkQuery();
    this.setTab();
  },
  destroyed() {
    document.documentElement.classList.remove("lock-scroll_only-devices");
    this.$store.commit("Search/setData", { label: "searchText", data: null });
    this.$store.commit("Search/setData", { label: "results", data: null });
    this.$store.commit("Search/setData", {
      label: "allResultsTab",
      data: null,
    });
    this.$store.commit("Search/setData", { label: "totalCount", data: null });
  },
  methods: {
    containsQuery() {
      const checkQueryParam = (string) => {
        return string.includes("query=");
      };
      return checkQueryParam(this.$route.fullPath);
    },
    filterChanged(filters) {
      this.updatesFilters = filters;
      this.$store
        .dispatch("Insights/getViewData", {
          url: `/insights/featured?${filters.queryParams}`,
        })
        .then(({ data }) => {
          this.$store.commit("Insights/setData", {
            label: "content",
            data,
          });
        });
      this.getResultsWithFilters(filters);
    },
    filterReset(queryObj) {
      this.$store.dispatch("Search/getSearchData", queryObj);
      this.$store
        .dispatch("Search/getViewData", {
          url: "/filters/search",
        })
        .then(({ data }) => {
          this.$store.commit("Search/setData", {
            label: "searchFilter",
            data,
          });
        })
        .catch((error) => console.error(error));
    },
    async getResults() {
      await this.$store.dispatch("Search/getSearchData", this.$route.query);
    },
    async getResultsWithFilters(filters) {
      const queryObj = {};
      queryObj.query = this.$route.query.query;
      queryObj.offset = this.$route.query.offset;
      queryObj.filters = this.$route.query.filters;
      queryObj.sortType = this.sortValue;

      if (filters.queryParams) {
        this.filtersArr = filters.queryParams.split("&");
        for (let i = 0; i < this.filtersArr.length; i++) {
          const pair = this.filtersArr[i].split("=");
          if (pair[0] !== "") {
            const key = pair[0].slice(0, -2);
            if (queryObj[key] === undefined) {
              queryObj[key] = [];
            }
            queryObj[key].push(decodeURIComponent(pair[1] || ""));
          }
        }
      }
      await this.$store.dispatch("Search/getSearchData", queryObj);
    },
    toggleSidebar() {
      this.showFilters = !this.showFilters;
      if (this.showFilters) {
        document.documentElement.classList.add("lock-scroll_only-devices");
      } else {
        document.documentElement.classList.remove("lock-scroll_only-devices");
      }
    },

    setTab() {
      // console.log(
      //   this.$route.query.tab,
      //   this.$refs.resultsTabs,
      //   this.$route.query.jurisdiction
      // );
      if (this.$route.query.tab) this.activeTab = this.$route.query.tab;
    },
    checkQuery() {
      if (this.$route.query.offset) {
        this.currentPage = +this.$route.query.offset / 10 + 1;
      }
      if (this.$route.query.query) {
        this.searchValue = this.$route.query.query;
      } else {
        this.searchValue = "";
      }
      if (this.$route.query.sortType) {
        this.sortValue = this.$route.query.sortType;
      } else {
        this.sortValue = "date";
      }
    },

    async handleClickSort(val) {
      this.sortValue = val;

      if (this.filtersArr.length > 0 || !this.filtersActive) {
        await this.getResultsWithFilters(this.updatesFilters);
      } else await this.getResults();
    },

    searchPagingTemp(page = 1) {
      // const query = {...this.$route.query, };
      const queryObj = {};
      queryObj.query = this.$route.query.query;
      // queryObj.offset = this.$route.query.offset;
      // filters = this.filtersArr;
      // console.log("filters", this.filtersArr)
      for (let i = 0; i < this.filtersArr.length; i++) {
        const pair = this.filtersArr[i].split("=");
        if (pair[0] !== "") {
          const key = pair[0].slice(0, -2);
          if (queryObj[key] === undefined) {
            queryObj[key] = [];
          }
          queryObj[key].push(decodeURIComponent(pair[1] || ""));
        }
      }
      queryObj.offset = 10 * page - 10;

      this.$router.push({ queryObj });

      setTimeout(() => {
        const scrollStep = -window.scrollY / (200 / 15);
        const scrollInterval = setInterval(function () {
          if (window.scrollY !== 0) {
            window.scrollBy(0, scrollStep);
          } else clearInterval(scrollInterval);
        }, 15);
      }, 300);
    },
    async searchPaging(page = 1) {
      const queryObj = {};
      queryObj.query = this.$route.query.query;
      queryObj.offset = 10 * page - 10;
      queryObj.filters = this.$route.query.filters;
      queryObj.sortType = this.sortValue;

      let filters = {};

      if (
        this.filtersArr.length === 0 &&
        this.$route.fullPath.includes("filter")
      ) {
        filters = this.filterTypeIdsFromUrl(this.$route.fullPath);
      } else filters = this.filtersArr;

      // console.log(filters);

      for (let i = 0; i < filters.length; i++) {
        const pair = filters[i].split("=");
        if (pair[0] !== "") {
          const key = pair[0].slice(0, -2);
          if (queryObj[key] === undefined) {
            queryObj[key] = [];
          }
          queryObj[key].push(decodeURIComponent(pair[1] || ""));
        }
      }
      // this.sortValue = val;
      await this.$store.dispatch("Search/getSearchData", queryObj);

      setTimeout(() => {
        const scrollStep = -window.scrollY / (200 / 15);
        const scrollInterval = setInterval(function () {
          if (window.scrollY !== 0) {
            window.scrollBy(0, scrollStep);
          } else clearInterval(scrollInterval);
        }, 15);
      }, 300);
    },
    checkHsAccess(jurisdictions) {
      const tids = [];
      for (let i = 0; i < jurisdictions.length; i++) {
        tids.push(jurisdictions[i]);
      }
      if (
        this.$store.state.Auth.subscriptions.legacy_permissions &&
        this.$store.state.Auth.subscriptions.legacy_permissions.length > 0
      ) {
        return checkAccess(
          this.$store.state.Auth.subscriptions.legacy_permissions,
          "viewHorizonScanning",
          tids
        );
      }
      return (
        this.$store.state.Auth.subscriptions.permissions &&
        this.$store.state.Auth.subscriptions.permissions.length > 0
      );
    },
    handleLinkAction(item) {
      if (this.$matomo) {
        this.$matomo.trackEvent("Watchlists", "Edit - Watchlist Block", item.name);
      }
      this.$router.push({
        path: "/watchlist_editor",
        query: { id: item.id }
      });
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";

.search-page {
  @include below($lg) {
    padding-top: 6rem;
  }

  .section {
    margin-bottom: 0;
  }

  &__info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 2.6rem;

    &-count {
      font-size: 1.3rem;

      span {
        font-weight: 700;

        &#results-for {
          color: $searchResults;
        }
      }
    }

    &-sorting {
      display: flex;
      align-items: center;

      &-label {
        margin-right: 1.3rem;
        font-size: 1.3rem;
        font-weight: 700;
      }

      .el-button {
        padding: 8px 16px;
      }

      .el-dropdown .el-dropdown__caret-button {
        padding-left: 5px;
        padding-right: 5px;
      }
    }
  }

  &__input {
    margin-bottom: 4rem;

    @include below($lg) {
      display: flex;
      align-items: center;

      .search {
        width: 100%;
      }

      .burger {
        margin-left: 2rem;
      }
    }
  }

  &__result {
    padding-top: 3rem;
  }

  &__pagination {
    display: flex;
    justify-content: center;
  }

  &__links {
    margin-bottom: 2rem;
    display: flex;
    flex-wrap: wrap;

    .link-el {
      width: 50%;
      @include below($md) {
        width: 100%;
      }
    }
  }
}
</style>
